<div class="timer" *ngIf="timeLeft$ | async as t">
  {{
    (t.daysLeft > 0 ? t.daysLeft.toString() + ':' : '') +
      (t.hoursLeft > 0 ? t.hoursLeft.toString().padStart(2, '0') + ':' : '') +
      (t.minutesLeft.toString().padStart(2, '0') + ':') +
      t.secondsLeft.toString().padStart(2, '0')
  }}
</div>
